import React from 'react';

import { Tooltip, IconButton } from '@material-ui/core';
import AddCircleOutlineRoundedIcon from '@material-ui/icons/AddCircleOutlineRounded';
import { toggleAddPostModal, postAddTagAction, postAddMentionAction } from 'actions/addPost';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { ADD_POST_MODAL_TYPES } from 'constants/ProjectConstants';
import theme from 'constants/theme';

function EndorseComponent({
  isEnterpriseUser,
  employee,
  tag,
  toggleModal,
  addHashTagToEditor,
  mentionEmployeeInEditor,
}) {
  const endorseTooltip = `Endorse ${employee.firstName}'s ${tag.name} capability`;

  function openModalWithTag() {
    mentionEmployeeInEditor(employee);
    addHashTagToEditor({ ...tag, stats: null, meshTags: null });
    toggleModal();
  }
  return (
    isEnterpriseUser && (
      <Tooltip title={endorseTooltip}>
        <StyledIconButton onClick={openModalWithTag}>
          <AddCircleOutlineRoundedIcon style={{ fill: theme.palette.icons.grey2 }} />
        </StyledIconButton>
      </Tooltip>
    )
  );
}

const mapDispatchToProps = (dispatch) => ({
  toggleModal: () => dispatch(toggleAddPostModal(ADD_POST_MODAL_TYPES.GIVE_KUDOS)),
  addHashTagToEditor: (tag) => dispatch(postAddTagAction(tag)),
  mentionEmployeeInEditor: (employee) => dispatch(postAddMentionAction(employee)),
});
export default connect(null, mapDispatchToProps, null)(EndorseComponent);

const StyledIconButton = styled(IconButton)`
  padding: 2px;
  margin-left: 4px;
`;
